import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth({
    clientId: import.meta.env.NG_APP_OKTA_CLIENT_ID,
    issuer: import.meta.env.NG_APP_OKTA_ISSUER,
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    postLogoutRedirectUri: window.location.origin + '/login',
});

export const oktaConfig = {
  oktaAuth
};